import { Body, Controller, Post } from '@nestjs/common';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ApiTags } from '@nestjs/swagger';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RmEvaluationInfo } from '../dto/rm-evaluation.dto';
import { RmEvaluationSamplesInfo } from '../dto/rm-evaluation-samples.dto';
import { RmEvaluationService } from './rm-evaluation.service';
import { GrnRequest } from '../dto/raw-material-grn.request';
import { RmEvaluationResponse } from '@gtpl/shared-models/raw-material-procurement';
import { RMGrnItemIdReq } from '../dto/grn-item-id.request';

@ApiTags('RM Evaluation')
@Controller('rm-evaluation')
export class RmEvaluationController {
    constructor(
        private service: RmEvaluationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createRmEvaluation')
    async createRmEvaluation(@Body() rmEInfo: RmEvaluationInfo): Promise<CommonResponse>{
        try{
            return await this.service.createRmEvaluationInfo(rmEInfo);
        }catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getRmEvaluationInfoByGrnId')
    async getRmEvaluationInfoByGrnId(@Body() req:RMGrnItemIdReq): Promise<RmEvaluationResponse>{
        try{
            return await this.service.getRmEvaluationInfoUsingGrnId(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(RmEvaluationResponse, error);
        }
    }
}